import { useContext, useEffect } from "react";
import { Navigate } from "react-router-dom";
import UserContext from "../../services/Context/UserContext";
import JWT from "../../services/JWT";

export default function Logout(){

    const {setUser} = useContext(UserContext)

    useEffect(() => {

        setUser(null)

        JWT.removeTokens();

        window.localStorage.removeItem('token') /*V1*/

    }, [setUser])
    
    
    return <Navigate to='/login' />
}